import { AbsoluteFill, Img, spring, staticFile, useCurrentFrame, useVideoConfig } from "remotion";
import { preloadImage } from "@remotion/preload";
// import { Gif } from '@remotion/gif';
import { Video } from 'remotion';
import './assets/css/Especs.css'
import { useEffect, useRef } from "react";

interface SeccionInterface {
	title: string,
	especificaciones: {
		icono: string,
		text: string
	}[],
	text: string
}

export const EspecificacionesSection = ({
	title,
	especificaciones,
	text
}: SeccionInterface) => {
	const frame = useCurrentFrame();
	const { durationInFrames, fps, width, height } = useVideoConfig();
	const ref = useRef<HTMLCanvasElement>(null);
	useEffect(() => {
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/01_FONDO.jpg"));
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/claro-white.svg"));
	}, []);
	const scaleSection = spring({
		fps,
		frame,
		config: { damping: 400, stiffness: 400 },
		from: 1,
		to: 2,
		delay: (durationInFrames - 8)
	});
	const blurSection = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 10,
		delay: (durationInFrames - 8)
	});

	const scalePhone = spring({
		fps,
		frame: frame * 3,
		config: { damping: 1, stiffness: 1 },
		from: 0,
		to: 1,
		delay: 0
	});

	const translateTitle = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 30
	});
	const opacityTitle = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 30
	});

	// ? MORE TITLE
	const scaleTextMore = spring({
		fps,
		frame: frame * 3,
		config: { damping: 1, stiffness: 1 },
		from: 0,
		to: 1,
		delay: 330
	});

	const translateTextMore = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 330
	});
	const opacityTextMore = spring({
		fps,
		frame,
		config: { damping: 300, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 330
	});

	let startingPoint = 0;
	const totalEspecificaciones = especificaciones?.length
	return (
		<AbsoluteFill style={{
			filter: (blurSection > 0) ? `blur(${blurSection}px)` : '',
			transform: `scale(${scaleSection})`
		}}>
			<AbsoluteFill style={{
				backgroundColor: "#B21F1D"
			}}>
				<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/03_FONDO.jpg")} style={{
					position: "absolute"
				}} />
			</AbsoluteFill>
			<AbsoluteFill>
				<div className="phone" style={{
					position: "absolute",
					top: "50%",
					left: 130,
					zIndex: 1,
					transform: `translateY(-50%) scale(${scalePhone})`,
				}}> 
					<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/Animacion-Iphone_sinfondo.gif")} style={{
						width: 416,
						height: 735,
						objectFit: "cover",
						filter: "blur(0px)"
					}} /> 

				</div>
				<div className="especificaciones" style={{
					position: "absolute",
					right: 273,
					top: "50%",
					minWidth: 880,
					transform: "translateY(-50%)",
				}}>
					<h1 style={{
						position: "relative",
						margin: 0,
						fontSize: 89,
						color: "#fff",
						fontWeight: "500",
						textShadow: "rgb(227 139 112 / 50%) 0px -5px 10px, rgb(227 139 112 / 50%) 0px -10px 20px, rgb(227 139 112 / 50%) 0px -15px 30px, rgb(132 109 136 / 50%) 0px 5px 10px, rgb(132 109 136 / 50%) 0px 10px 20px, rgb(132 109 136 / 50%) 0px 15px 30px, rgb(255, 255, 255) 0px 0px 5px",
						opacity: opacityTitle,
						transform: `translateY(${translateTitle}px)`
					}}>{title}</h1>
					<ul className="list">
						{especificaciones.map((value, index) => {
							startingPoint += 50;
							const currentIndex = index + 1;
							const currentIconScale = spring({
								fps,
								frame,
								config: { damping: 300, stiffness: 100 },
								from: 0,
								to: 1,
								delay: startingPoint
							});
							const currentTextOpacity = spring({
								fps,
								frame,
								config: { damping: 300, stiffness: 100 },
								from: 0,
								to: 1,
								delay: startingPoint + 10
							});
							const currentTextScale = spring({
								fps,
								frame,
								config: { damping: 300, stiffness: 100 },
								from: 0.5,
								to: 1,
								delay: startingPoint + 10
							});
							const currentLineWidth = spring({
								fps,
								frame,
								config: { damping: 50, stiffness: 30 },
								from: 0,
								to: 100,
								delay: startingPoint + 15
							});
							return (
								<li key={value.text}>
									<div className="icon" style={{
										position: "relative",
										transform: `scale(${currentIconScale})`
									}}>
										<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/" + value.icono)} style={{
											width: 56
										}} />
									</div>
									<span style={{
										position: "relative",
										opacity: currentTextOpacity,
										transformOrigin: "left",
										transform: `scale(${currentTextScale})`,
									}}>{value.text}</span>
									{totalEspecificaciones != currentIndex ? (
										<div className="line" style={{
											width: `${currentLineWidth}%`
										}}></div>
									) : null}
								</li>
							);
						})}
					</ul>
					<p style={{
						margin: 0,
						fontSize: 67,
						color: "#fff",
						fontWeight: "500",
						textAlign: "right",
						opacity: opacityTextMore,
						transform: `scale(${scaleTextMore}) translateY(${translateTextMore}px)`
					}}>{text}</p>
				</div>
			</AbsoluteFill>
		</AbsoluteFill>
	);
};